import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class TmsDemirbasService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public belediyeCode : number;
    public ambarKod!: number;
    public verilenPersonelKod!: number;
    public demirbasYerKod!: number;
    public islemTuru!: string;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}

     setParams(ambarKod: number, verilenPersonelKod:number, demirbasYerKod:number, islemTuru:string,isReadOnly:boolean, isBindCheck:boolean){
      this.ambarKod = ambarKod;
      this.verilenPersonelKod = verilenPersonelKod;
      this.demirbasYerKod = demirbasYerKod;
      this.islemTuru=islemTuru;
      this.isReadOnly = isReadOnly;
      this.isBindCheck = isBindCheck;
    }
  getData(code: string,control:any, ambarKod?:number, verilenPersonelKod?:number, demirbasYerKod?:number, islemTuru?:string, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select([]);
    if(ambarKod){filterArr.push(['AmbarKod', '=', ambarKod])}
    if(verilenPersonelKod){filterArr.push(['VerilenPersonelKod', '=', verilenPersonelKod])}
    if(demirbasYerKod){filterArr.push(['DemirbasYerKod', '=', demirbasYerKod])}
    if(islemTuru){filterArr.push(['IslemTuru', '=', islemTuru])}
    }
    if(code)filterArr.push(['SicilKod', '=', code]);

    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
